// dialog-controller.ts
import { InjectionToken } from '@angular/core';

export interface DialogController {
  emitData(data: any): void;
  close(result?: any): void;
  dismiss(reason?: any): void;
}

export const DIALOG_CONTROLLER = new InjectionToken<DialogController>('DIALOG_CONTROLLER');